import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { SITE_ENGINEER_LISTING } from "./type";

export const getSiteEngineerList = (page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.siteEngineerList}?page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_ENGINEER_LISTING, payload: data.response.data });
    return data.response.data;
  }
};

